export default "__VITE_PUBLIC_ASSET__d97ea19b__"